import { checkAuth } from '@/services/auth'
import MatchStatsList from '@/views/match-stats/MatchStatsList'
import MatchStatsDetail from '@/views/match-stats/MatchStatsDetail'
import UserStatsOverride from '@/views/match-stats/UserStatsOverride'
import MatchLeaderboard from '@/views/match-stats/MatchLeaderboard'

export default [
    {
        path: '/match-stats',
        name: 'matchStatsList',
        component: MatchStatsList,
        beforeEnter(to, from, next) {
            checkAuth().then(ok => ok ? next() : next('/login'));
        },
    },
    {
        path: '/match-stats/user-override',
        name: 'matchStatsUserOverride',
        component: UserStatsOverride,
        beforeEnter(to, from, next) {
            checkAuth().then(ok => ok ? next() : next('/login'));
        },
    },
    {
        path: '/match-stats/leaderboard',
        name: 'matchStatsLeaderboard',
        component: MatchLeaderboard,
        beforeEnter(to, from, next) {
            checkAuth().then(ok => ok ? next() : next('/login'));
        },
    },
    {
        path: '/match-stats/:matchId',
        name: 'matchStatsDetail',
        component: MatchStatsDetail,
        beforeEnter(to, from, next) {
            checkAuth().then(ok => ok ? next() : next('/login'));
        },
    },
]
